import { cn } from '@/lib/utils'

export type CategoryFilterChipProps = {
  label: string
  active: boolean
  onClick: () => void
}

/**
 * CategoryFilterChip — pill-style filter chip shared by `/blog` and `/glossary`
 * category filter rows. Active = solid primary fill; inactive = hairline border.
 *
 * WHEN: any marketing-page category/topic filter row.
 * NEVER: hand-roll the pill classes inline — extend this component instead.
 */
export function CategoryFilterChip({
  label,
  active,
  onClick,
}: CategoryFilterChipProps): React.ReactElement {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={cn(
        'rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors duration-200',
        active
          ? 'border-primary bg-primary text-primary-foreground'
          : 'border-border bg-background text-muted-foreground hover:border-primary/30 hover:text-foreground'
      )}
    >
      {label}
    </button>
  )
}
